import { Component, OnInit, Input } from '@angular/core';
import { NbCalendarRange } from '@nebular/theme';
import { LenguageService } from '../../../@core/utils/lenguage.service'

@Component({
  selector: 'ngx-single-number',
  templateUrl: './single-number.component.html',
  styleUrls: ['./single-number.component.scss']
})
export class SingleNumberComponent implements OnInit {
  @Input() title: string;
  @Input() type: string;
  loading: boolean = true;
  timeFrame: string = 'today';
  timeRange: {
    dateStart: number,
    dateEnd: number
  }
  dateRange: NbCalendarRange<Date>;
  data: any;
  constructor(
    public language: LenguageService
  ) { }

  ngOnInit() {
    this.timeChanged()
  }

  rangeChanged() {

    if (this.dateRange.start && this.dateRange.end) {
      this.timeChanged()
    }
  }

  timeChanged() {
    let interval = 1000 * 60 * 60 * 24; // 24 hours in milliseconds
    let dateStart = Math.floor(Date.now() / interval) * interval;
    let dateEnd = Date.now();
    this.timeRange = { dateStart, dateEnd };

    switch (this.timeFrame) {
      case "today":
        interval = 1000 * 60 * 60 * 24; // 24 hours in milliseconds
        dateStart = Math.floor(Date.now() / interval) * interval;
        dateEnd = Date.now();
        this.timeRange = { dateStart, dateEnd };

        break;

      case "yesterday":
        interval = 1000 * 60 * 60 * 24; // 24 hours in milliseconds
        dateStart = Math.floor(Date.now() / interval) * interval - interval;
        dateEnd = Math.floor(Date.now() / interval) * interval;
        this.timeRange = { dateStart, dateEnd };

        break;

      case "week":
        let d = new Date();
        let day = d.getDay();
        let diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
        d.setDate(diff);
        dateStart = d.getTime();
        dateEnd = Date.now();
        this.timeRange = { dateStart, dateEnd };

        break;

      case "month":
        let currentDate = new Date();
        dateEnd = Date.now();
        dateStart = new Date((currentDate.getMonth() + 1) + "-1-" + currentDate.getFullYear() + " 00:00").getTime() * 1000 / 1000;
        this.timeRange = { dateStart, dateEnd };

        break;

      default:
        break;
    }

    this.getData(dateStart, dateEnd);
  }


  async getData(dateStart, dateEnd) {
    this.loading = true;
    //this.data = await this.SplitTestService.getSplitTestsStats(dateStart, dateEnd)
    this.loading = false;
  }

}
